import 'website/src/scss/faq/topic-details.scss';

const addEvents = () => {


    document.querySelectorAll('.clickable-image').forEach(img => {
        img.addEventListener('click', () => {
            const box = document.getElementById('box');
            const boxImg = document.getElementById('box-img');
            boxImg.src = img.src;
            box.style.display = 'flex';
        });
    });

    document.getElementById('box').addEventListener('click', (e) => {
        if (e.target.id === 'box') {
            e.target.style.display = 'none';
        }
    });
};

addEvents();